import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

export function useIsClientSide() {
  const [isClient, setClient] = useState(false);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setClient(true);
    }
  }, []);
  return isClient;
}

export function useIsMobile() {
  return useMediaQuery({ query: '(max-width: 640px)' });
}
